import { Component, Input, OnInit } from '@angular/core';
import { ExerciseContainer } from '../../agenda/agenda.component';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { GroupModel } from 'projects/runner/src/app/models/group.model';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';

@Component({
  selector: 'app-agenda-exercise-group',
  templateUrl: './agenda-exercise-group.component.html',
  styleUrls: ['./agenda-exercise-group.component.scss']
})
export class AgendaExerciseGroupComponent implements OnInit {

  @Input() container: ExerciseContainer = null;

  constructor(
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
  }

  public hasPause(group: GroupModel, candidate: CandidateModel): boolean {
    if (this.auth.isCandidate() === true) {
      return this.auth.isMe(candidate.hashed_id) === false;
    } else if (this.auth.isObserver() === true) {

    }
    return false;
  }

  public isAssigned(): boolean {
    let assigned = false;
    for (let group of this.container?.exercise?.groups) {
      if (group.isInGroup(this.auth.getHashedId())) {
        assigned = true;
        break;
      }
    }
    return this.auth.isModerator() || assigned;
  }

}
